require('angular').module('wowApp.common')
    .service('ProxyService', ['Restangular', require('./proxy-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/proxyservice/index.js
 **/